export type TNativeMediaStreamAudioSourceNode = MediaStreamAudioSourceNode;
